module.exports = __webpack_public_path__ + "static/media/remove_player.8edb8069.svg";